/* eslint-disable camelcase */
export default class ProductMappingInfo {
  constructor ({ description, not_mapped, quantity_sold, stock_quantity }) {
    this.description = description || ''
    this.notMapped = not_mapped || 0
    this.quantitySold = quantity_sold || 0
    this.stockQuantity = stock_quantity || 0
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/models/ProductMappingInfo.js